import styles from './Button.module.css';

interface ButtonProps {
	variant?: 'primary' | 'secondary' | 'destructive';
	disabled?: boolean;
	loading?: boolean;
	onClick?: () => void;
	type?: 'button' | 'submit';
	children: React.ReactNode;
	className?: string;
}

export function Button({
	variant = 'secondary',
	disabled = false,
	loading = false,
	onClick,
	type = 'button',
	children,
	className,
}: ButtonProps) {
	const variantClass = styles[variant] ?? styles.secondary;

	return (
		<button
			type={type}
			className={[styles.button, variantClass, className].filter(Boolean).join(' ')}
			disabled={disabled || loading}
			onClick={onClick}
		>
			{loading && (
				<svg className={styles.spinner} viewBox="0 0 24 24" fill="none" aria-hidden="true">
					<circle
						className={styles.spinnerCircle}
						cx="12"
						cy="12"
						r="10"
						strokeWidth="2.5"
						strokeDasharray="31.4"
						strokeDashoffset="10"
					/>
				</svg>
			)}
			{children}
		</button>
	);
}
